import API from "./Api";


/* ================== COUNTRY ================== */
export const getAllCountries = async () => {
  const { data } = await API.get("/countries/getAll");
  return data;
};

export const addCountry = async (payload) => {
  const { data } = await API.post("/countries/add", payload);
  return data;
};

export const updateCountry = async (id, payload) => {
  const { data } = await API.put(`/countries/update/${id}`, payload);
  return data;
};

/* ================== STATE ================== */
export const getAllStates = async () => {
  const res = await API.get("/states/getAll");
  return res.data;
};

export const getStatesByCountry = async (countryId) => {
  const { data } = await API.get(`/states/by-country/${countryId}`);
  return data;
};

export const addState = async (payload) => {
  const { data } = await API.post("/states/add", payload);
  return data;
};

export const updateState = async (id, payload) => {
  const { data } = await API.put(`/states/update/${id}`, payload);
  return data;
};

/* ================== DISTRICT ================== */
export const getDistrictsByState = async (stateId) => {
  const res = await API.get(`/districts/by-state/${stateId}`);
  return res.data;
};

export const addDistrict = async (payload) => {
  const { data } = await API.post("/districts/add", payload);
  return data;
};

export const updateDistrict = async (id, payload) => {
  const { data } = await API.put(`/districts/update/${id}`, payload);
  return data;
};

/* ================== TALUKA ================== */
export const getTalukasByDistrict = async (districtId) => {
  const res = await API.get(`/talukas/by-district/${districtId}`);
  return res.data;
};

export const addTaluka = async (payload) => {
  const { data } = await API.post("/talukas/add", payload);
  return data;
};

export const updateTaluka = async (id, payload) => {
  const { data } = await API.put(`/talukas/update/${id}`, payload);
  return data;
};